import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMatter } from "../context/MatterContext";
import { useModules } from "../context/ModulesContext";
import {
  findBhpRetainerModuleForMatter,
  isRetainerSignedModule,
} from "../modules/moduleUtils";
import FullscreenLoader from "./FullscreenLoader";
import "../styles/ProjectRRetainerGate.css";

const getAuthFlow = () => {
  return (
    localStorage.getItem("authFlow") || sessionStorage.getItem("authFlow") || ""
  );
};

// Routes where the Project R consent flow itself is rendered - the gate must
// let these through, otherwise a client could never reach the terms to
// agree/skip them.
const EXEMPT_PATH_SUFFIXES = [
  "/important",
  "/important-consumer-info",
  "/summary-updates",
];

const isExemptPath = (pathname) => {
  return EXEMPT_PATH_SUFFIXES.some(
    (suffix) => pathname === suffix || pathname.endsWith(suffix),
  );
};

export default function ProjectRRetainerGate({ children }) {
  const { party, matter, bootstrapping, bootstrapState } = useMatter();
  const { modules, modulesInitialized } = useModules();
  const location = useLocation();
  const navigate = useNavigate();

  const isPortalUserFlow = getAuthFlow() === "portal_user";
  const matterId = matter?.id || matter?.matterId || "";

  const activeModule = useMemo(() => {
    return findBhpRetainerModuleForMatter(modules, matterId);
  }, [modules, matterId]);

  const shouldWaitForModules =
    isPortalUserFlow &&
    !!party &&
    !bootstrapping &&
    bootstrapState === "ready" &&
    !modulesInitialized;

  if (shouldWaitForModules) {
    return (
      <FullscreenLoader
        title="Carregando"
        message="Estamos verificando o acesso ao portal."
      />
    );
  }

  // Not a portal-user session, no matter selected yet, or nothing to sign -
  // let everything through as usual.
  if (!isPortalUserFlow || !matterId || !activeModule) {
    return children;
  }

  if (isRetainerSignedModule(activeModule)) {
    return children;
  }

  // Always allow the consent flow's own pages to render, so the client can
  // actually reach and complete/skip it.
  if (isExemptPath(location.pathname)) {
    return children;
  }

  const handleReviewTerms = () => {
    navigate("/important");
  };

  return (
    <div className="projectRGatePage">
      <div className="projectRGatePanel">
        <h1 className="projectRGateTitle">Ação Necessária</h1>
        <p className="projectRGateMessage">
          Para continuar utilizando o portal, é necessário revisar e
          confirmar os novos termos do seu contrato.
        </p>
        <p className="projectRGateMessage projectRGateMessageSecondary">
          Enquanto isso, o restante do portal ficará bloqueado até que os
          termos sejam confirmados.
        </p>
        <div className="projectRGateActions">
          <button
            type="button"
            className="projectRGateButton"
            onClick={handleReviewTerms}
          >
            Ver termos
          </button>
        </div>
      </div>
    </div>
  );
}
